export default "__VITE_ASSET__CROdYpL9__"